<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "6rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96"><path d="M48 12a36 36 0 11-36 36 36 36 0 0136-36m0-4a40 40 0 1040 40A40 40 0 0048 8z"/><path d="M40 34.17L64 48 40 61.83V34.17m2 31.12l24-13.83a4 4 0 000-6.92L42 30.71a4 4 0 00-6 3.46v27.66a4 4 0 006 3.46z"/></svg>